// Libs
import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import _ from 'lodash'

// CSS
import './styles.scss'

// Containers/Components
import Breadcrumb from '../../components/Breadcrumb'
import Button from '../../components/Button'

class WelcomePage extends Component {
  render() {
    const { user: { name }, notifications } = this.props
    let count = ''
    let count1 = ''
    let count2 = ''
    let count3 = ''

    notifications.map((notification, idx) => {
      switch (notification.status) {
        case 1:
          count1++
          break;
        case 2:
          count2++
          break;
        case 3:
          count3++
          break;
        default:
      }

      if (notifications.length !== (idx + 1)) {
        if (!count1) count1 = 0
        if (!count2) count2 = 0
        if (!count3) count3 = 0
        if (notifications.length) {
          count = notifications.length
        } else {
          count = 0
        }
      }
    })

    return (
      <div className="welcome-page">
        <Breadcrumb routes={[`Olá, ${name}`]} />
        <div className="welcome-page__card">
          <h2>
            Você possui {count} {notifications.length === 1 ? ' pendência' : ' pendências'}</h2>
          <h3>Resolva suas pendências e celebre acordos.</h3>
          <div className="welcome-page__button">
            <Button>Resolver Última Pendência</Button>
          </div>
        </div>
      </div>
    )
  }
}

WelcomePage = connect(state => {
  return {
    user: state.auth.user,
    notifications: state.notify.notifications
  }
}, {})(WelcomePage)

export default WelcomePage
